module.exports = __webpack_public_path__ + "assets/text_formatting.de56367a.svg";